import Vue from 'vue'
import Router from 'vue-router'

const Matrix = resolve => require(['@/views/Matrix'], resolve)
const Home = resolve => require(['@/views/Home'], resolve)
const Derivative = resolve => require(['@/views/Derivative'], resolve)
const Simplify = resolve => require(['@/views/Simplify'], resolve)
const Latex = resolve => require(['@/views/Latex'], resolve)
const Hex = resolve => require(['@/views/Hex'], resolve)
const Test = resolve => require(['@/views/Test'], resolve)
const Error404 = resolve => require(['@/views/error/Error404'], resolve)
const BigNumberCalculator = resolve => require(['@/views/BigNumberCalculator'], resolve)
const Prime = resolve => require(['@/views/Prime'], resolve)
const Sqrt = resolve => require(['@/views/Sqrt'], resolve)

Vue.use(Router)

let routes = [
    {
        path: '/',
        component: Home
        // redirect: '/matrix'
    },
    { path: '/complex', component: resolve => require(['@/views/Complex'], resolve) },
    { path: '/expressTree', component: resolve => require(['@/views/ExpressTree'], resolve) },
    { path: '/triangle', component: resolve => require(['@/views/Triangle'], resolve) },
    { path: '/definiteIntegral', component: resolve => require(['@/views/DefiniteIntegral'], resolve) },
    { path: '/integral', component: resolve => require(['@/views/Integral'], resolve) },
    { path: '/rationalize', component: resolve => require(['@/views/Rationalize'], resolve) },
    { path: '/factor', component: resolve => require(['@/views/Factor'], resolve) },
    {
        path: '/matrix',
        component: Matrix
    },
    {
        path: '/sqrt',
        component: Sqrt
    },
    {
        path: '/derivative',
        component: Derivative
    },
    {
        path: '/simplify',
        component: Simplify
    },
    {
        path: '/latex',
        component: Latex
    },
    {
        path: '/hex',
        component: Hex
    },
    {
        path: '/test',
        component: Test
    },
    {
        path: '/calculator/bignumber',
        component: BigNumberCalculator
    },
    {
        path: '/prime',
        component: Prime
    },
    {
        path: '*',
        component: Error404
    }
]

let router = new Router({
    mode: 'history',
    routes: routes,
    scrollBehavior (to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js